import floorService from '@/services/floor.js';
import mapService from '@/services/map.js';
import fileService from '@/services/file.js';

export default {
	debug: false,
	namespaced: true,
	state: {
		floors: [],
		floor: {},
		roundFloors: [],
		searchParams: {
			name: '',
			orderBy: '',
			buildingId: '',
			pageSize: 10,
			currentPage: 1
		},
		totalCount: 0,
		totalPages: 0
	},

	mutations: {
		SET_FLOORS(state, floors) {
			state.floors = floors;
		},
		SET_FLOOR(state, floor) {
			state.floor = floor;
		},
		SET_ROUND_FLOORS(state, floors) {
			state.roundFloors = floors;
		},
		SET_PAGESIZE(state, pageSize) {
			state.searchParams.pageSize = pageSize;
		},
		SET_CURRENTPAGE(state, currentPage) {
			state.searchParams.currentPage = currentPage;
		},
		SET_TOTALPAGES(state, totalPages) {
			state.totalPages = totalPages;
		},
		SET_TOTALCOUNT(state, totalCount) {
			state.totalCount = totalCount;
		}
	},

	actions: {
		async getFloor({ commit }, floorId) {
			return await floorService
				.getFloor(floorId)
				.then(data => {
					commit('SET_FLOOR', data);
				})
				.catch(err => {
					console.log('Error getting floor: ', err);
				});
		},
		async getFloors({ state, commit, dispatch }) {
			dispatch('appStore/setLoading', 1, { root: true });

			return await floorService
				.getFloors(state.searchParams)
				.then(data => {
					const paginationValues = data._pagination;

					if (state.searchParams.currentPage <= paginationValues.totalPages || paginationValues.totalPages == 0) {
						commit('SET_FLOORS', data);
						commit('SET_CURRENTPAGE', paginationValues.currentPage);
						commit('SET_TOTALCOUNT', paginationValues.totalCount);
						commit('SET_TOTALPAGES', paginationValues.totalPages);
					} else {
						commit('SET_CURRENTPAGE', paginationValues.totalPages);
						dispatch('getFloors');
					}

					dispatch('appStore/setLoading', -1, { root: true });
				})
				.catch(err => {
					console.log('Error getting floors: ', err);
					dispatch('appStore/setLoading', -1, { root: true });
				});
		},
		async getRoundFloors({ commit, dispatch }, roundPlanningId) {
			dispatch('appStore/setLoading', 1, { root: true });
			var searchParams = {
				roundPlanningId,
				orderBy: 'Name',
				currentPage: 1,
				pageSize: 1000
			};

			return await floorService
				.getFloors(searchParams)
				.then(data => {
					commit('SET_ROUND_FLOORS', data);
					dispatch('appStore/setLoading', -1, { root: true });
				})
				.catch(err => {
					console.log('Error getting floors: ', err);
					dispatch('appStore/setLoading', -1, { root: true });
				});
		},
		async createFloor({ dispatch }, floor) {
			return await floorService
				.createFloor(floor)
				.then(data => {
					dispatch('getFloors');

					return data;
				})
				.catch(err => {
					console.log('Error creating floor: ', err);
				});
		},
		async updateFloor({ dispatch }, floor) {
			return await floorService
				.updateFloor(floor)
				.then(() => {
					dispatch('getFloors');
				})
				.catch(err => {
					console.log('Error updating floor: ', err);
				});
		},
		async deleteFloor({ dispatch }, floor) {
			return await floorService
				.deleteFloor(floor.id)
				.then(() => {
					dispatch('getFloors');
				})
				.catch(err => {
					console.log('Error deleting floor: ', err);
				});
		},
		async deleteFloorWithMap({ dispatch }, floor) {
			try {
				const mapData = await mapService.getMaps({
					floorId: floor.id,
					pageSize: 99,
					currentPage: 1
				});

				const filesPromises = mapData.map(
					map => map.file && fileService.deleteFile(map.file.id)
				);
				await Promise.all(filesPromises);

				const mapsPromises = mapData.map(map =>
					mapService.deleteMap(map.id)
				);

				await Promise.all(mapsPromises);
				/*
				const promiseObj = await Promise.all(mapsPromises);
				const hasErrors = promiseObj.reduce(
					(acc, curr) => !curr.data.success && curr.data.errors[0],
					''
				);

				if (hasErrors) {
					throw hasErrors;
				}
				*/

				return await floorService.deleteFloor(floor.id).then(() => {
					dispatch('getFloors');
				});
			} catch (err) {
				console.error(err);
			}
		},

		setFloor({ commit }, floor) {
			commit('SET_FLOOR', floor);
		},
		setFloors({ commit }, floors) {
			commit('SET_FLOORS', floors);
		},
		setCurrentPage({ commit }, currentPage) {
			commit('SET_CURRENTPAGE', currentPage);
		},
		setPageSize({ commit }, pageSize) {
			commit('SET_PAGESIZE', pageSize);
		},
		setTotalPages({ commit }, totalPages) {
			commit('SET_TOTALPAGES', totalPages);
		},
		setTotalCount({ commit }, totalCount) {
			commit('SET_TOTALCOUNT', totalCount);
		}
	},

	getters: {
		totalPages: state => {
			return state.totalPages;
		},
		totalCount: state => {
			return state.totalCount;
		},
		currentPage: state => {
			return state.searchParams.currentPage;
		},
		pageSize: state => {
			return state.searchParams.pageSize;
		},
		floors: state => {
			return state.floors;
		},
		floor: state => {
			return state.floor;
		},
		roundFloors: state => {
			return state.roundFloors;
		},
		dropdownFloors: state => {
			return state.dropdownFloors;
		},
		pagination: state => {
			return {
				currentPage: state.searchParams.currentPage,
				pageSize: state.searchParams.pageSize,
				totalPages: state.totalPages,
				totalCount: state.totalCount
			};
		},
		selectedFloor: state => {
			return state.selectedFloor;
		}
	}
};
